import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { adminApi, setToken } from "./adminApi";
import { ArrowUpRight } from "lucide-react";

const AdminLogin = () => {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError(null);
    try {
      const { token } = await adminApi.login(password);
      setToken(token);
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(err.message || "Login failed");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-canvas text-ink flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="mb-8 text-center">
          <p className="text-[10px] tracking-[0.4em] uppercase text-ink/55 mb-3">
            SAMURAI · CMS
          </p>
          <h1 className="font-heading font-black text-4xl md:text-5xl tracking-[-0.03em] uppercase">
            Admin{" "}
            <span className="italic font-serif font-normal text-ink/70 normal-case">
              access.
            </span>
          </h1>
        </div>

        <form
          onSubmit={submit}
          className="bg-surface border border-ink/10 rounded-2xl p-8 space-y-6"
          data-testid="admin-login-form"
        >
          <div>
            <label className="block text-[10px] tracking-[0.32em] uppercase text-ink/55 mb-3">
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoFocus
              className="w-full bg-transparent border-b border-ink/25 focus:border-ink outline-none py-2 text-ink transition-colors text-base"
              data-testid="admin-login-password"
            />
          </div>

          {error && (
            <p className="text-[11px] tracking-[0.2em] uppercase text-red-400" data-testid="admin-login-error">
              {error}
            </p>
          )}

          <button
            type="submit"
            disabled={submitting || !password}
            className="group inline-flex items-center gap-3 disabled:opacity-50"
            data-testid="admin-login-submit"
          >
            <span className="text-[11px] uppercase tracking-[0.32em]">
              {submitting ? "Signing in" : "Enter"}
            </span>
            <span className="w-10 h-10 rounded-full bg-ink text-canvas flex items-center justify-center transition-transform duration-500 group-hover:rotate-45">
              <ArrowUpRight className="w-4 h-4" />
            </span>
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
